import { showAPIerror } from "./Helpers";
import { sllrProfAxios } from "./axiosDefault";
import { setApiStatus,setShowSuccessPopUp } from "../../../redux/slices/sellerProfileSlice";

const getSellerAndUserIDs = (states, setStates,spPageText) => {
  const getDefaultCoProfile = async () => await sllrProfAxios.get("");

  return getDefaultCoProfile()
    .then((res) => {
      states.forEach(async (api: string, i) => {
        setStates[i](res.data[api]);
      });
      return res;
    })
    .catch((error) => showAPIerror(error,setApiStatus,setShowSuccessPopUp,spPageText, "getSellerAndUserIDs"));
};

export default getSellerAndUserIDs;
